const React = require('react');


/* eslint-disable */
module.exports = (props) => {
  return (
    <svg
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={`dB fillCT>path ` + (props.className || '')}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.2949 0.086827C15.4852 0.0770192 15.6707 0.148678 15.805 0.283884C15.9392 0.418903 16.0096 0.604594 15.9987 0.794622C15.4665 10.1528 7.1356 13.665 7.05181 13.6991C6.80208 13.8012 6.51548 13.7437 6.32456 13.553L2.53279 9.76136C2.34309 9.57138 2.28506 9.28653 2.38533 9.03748C2.41884 8.95303 5.89223 0.577457 15.2949 0.086827ZM8.87051 7.94086C9.37149 8.14832 9.94812 8.03356 10.3315 7.65009C10.8548 7.12662 10.8548 6.27807 10.3315 5.75459C9.94812 5.37112 9.37149 5.25636 8.87051 5.46382C8.36953 5.67129 8.04287 6.16011 8.04287 6.70234C8.04287 7.24457 8.36953 7.7334 8.87051 7.94086Z"
      />
      <path d="M0.746021 12.6301C1.22704 12.1458 1.9303 11.9557 2.58984 12.1316C3.24937 12.3075 3.76451 12.8226 3.94043 13.4822C4.11635 14.1417 3.9262 14.8449 3.44189 15.3259C2.69721 16.0706 0 16.086 0 16.086C0 16.086 0 13.3741 0.746021 12.6301Z"/>
      <path d="M6.94196 1.56867C5.02471 1.23499 3.06509 1.85624 1.69032 3.2336C1.33186 3.59537 1.0202 4.0007 0.762654 4.44007C0.607534 4.70345 0.650268 5.03842 0.866547 5.25443L2.19973 6.58825C3.43856 4.62225 5.04946 2.91714 6.94196 1.56867Z"/>
      <path d="M14.5168 9.14402C14.8505 11.0612 14.2292 13.0208 12.8518 14.3955C12.49 14.754 12.0847 15.0656 11.6453 15.3232C11.3819 15.4783 11.0469 15.4355 10.8309 15.2193L9.49707 13.8861C11.4631 12.6473 13.1683 11.0365 14.5168 9.14402Z"/>
    </svg>
  );
};
